import React, { useEffect, useRef, useState } from "react";
import { SearchBox } from "@quintype/components";
import { useDispatch, useSelector } from "react-redux";
import { func, array, string } from "prop-types";
import get from "lodash/get";

import { OPEN_SEARCHBAR } from "../../../store/actions";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import Filter from "./filter";
import { staticTexts } from "../../../utils/translate";
import "./search-form.m.css";

function DrawForm({ children }) {
  return [
    <div key="1" styleName="drawform">
      <label className="qt-search__form-label" htmlFor="searchForm">
        {children}
      </label>
      <button className="search-icon">
        <SvgIconHandler type="search" width="24" height="24" viewBox="0 0 24 24" />
      </button>
    </div>,
  ];
}

DrawForm.propTypes = {
  children: func,
};

const SearchForm = ({ query, updateStories, sections, setparams, setSortType }) => {
  const lang = useSelector((state) => get(state, ["qt", "config", "publisher-attributes", "lang"], ""));

  const sortOptions = [
    {
      name: `${staticTexts(lang).relevance}`,
      filterKey: "score",
    },
    {
      name: `${staticTexts(lang).newest}`,
      filterKey: "latest-published",
    },
  ];
  const [isSortOpen, setSortOpen] = useState(false);
  const [selectedSort, setSelectedSort] = useState(sortOptions[0].name);
  const [showFilter, setShowFilter] = useState(false);

  const dispatch = useDispatch();

  const closeSearchBar = () => {
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: false,
    });
  };

  const handleSortChange = (item) => {
    setSelectedSort(item.name);
    setSortType(item.filterKey);
    setSortOpen(false);
  };

  const customStyle = {
    display: showFilter ? "block" : "none",
  };

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          if (
            ref.current.innerHTML.includes(`${staticTexts(lang).relevance}`) ||
            ref.current.innerHTML.includes(`${staticTexts(lang).newest}`)
          ) {
            setSortOpen(false);
          } else {
            global.deviceWidth < 768 && setShowFilter(false);
          }
        }
      }
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef1 = useRef(null);
  const wrapperRef2 = useRef(null);
  useOutsideAlerter(wrapperRef1);
  useOutsideAlerter(wrapperRef2);

  useEffect(() => {
    global.deviceWidth > 767 && setShowFilter(true);
  }, []);

  return (
    <div styleName="wrapper">
      <SearchBox
        template={DrawForm}
        inputId="searchForm"
        inputClassName="search__form-input"
        onSubmitHandler={() => closeSearchBar()}
        onEscape={() => closeSearchBar()}
        placeholder={query}
      />
      <div styleName="content-wrapper">
        <div styleName="button filter-button" data-test-id="filter-btn" ref={wrapperRef1}>
          <div
            onClick={() => {
              global.deviceWidth < 767 && setShowFilter(!showFilter);
              setSortOpen(false);
            }}
            styleName="filter-block"
          >
            {staticTexts(lang).filter}
          </div>
          <div style={customStyle}>
            <Filter sections={sections} setparams={setparams} />
          </div>
        </div>
        <div
          styleName={`button relevance-button ${isSortOpen ? "open-sort" : ""}`}
          onClick={() => {
            setSortOpen(!isSortOpen);
            global.deviceWidth < 767 && setShowFilter(false);
          }}
          ref={wrapperRef2}
          data-test-id="relevance-button"
        >
          {selectedSort}
          {isSortOpen && (
            <ul styleName="dropdown-wrapper" data-test-id="relevance-dropdown-wrapper">
              {sortOptions.map((item, index) => (
                <li
                  styleName="sort-item"
                  key={`dropdown-${index}`}
                  data-value={JSON.stringify(item)}
                  data-parent={"sort"}
                  data-item="list-item"
                  onClick={() => handleSortChange(item)}
                >
                  {item.name}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div>{staticTexts(lang).sortBy}</div>
      </div>
    </div>
  );
};

SearchForm.propTypes = {
  query: string,
  updateStories: func,
  sections: array,
  setparams: func,
  setSortType: func,
};

export default SearchForm;
